import { createContext, useState, useEffect, useContext, useCallback } from 'react';
import i18n from '../i18n/config';
import { detectLanguage } from '../i18n/detectLanguage';
import { LANGUAGES, resolveLanguageId } from '../constants/languages';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [myLanguage, setMyLanguageState] = useState(() => {
    const stored = localStorage.getItem('myLanguage');
    if (!stored) return detectLanguage();
    const normalized = resolveLanguageId(stored) || 'en';
    // 기존 사용자의 'Korean' 등 이름 문자열을 2자리 소문자 코드로 자동 치유
    if (stored !== normalized) {
      localStorage.setItem('myLanguage', normalized);
    }
    return normalized;
  });

  const setMyLanguage = useCallback((lang) => {
    const normalized = resolveLanguageId(lang) || 'en';
    setMyLanguageState(normalized);
  }, []);

  useEffect(() => {
    const langCode = resolveLanguageId(myLanguage) || 'en';
    localStorage.setItem('myLanguage', langCode);
    i18n.changeLanguage(langCode);
  }, [myLanguage]);

  return (
    <LanguageContext.Provider value={{ myLanguage, setMyLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
